import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum IrpfRetentionPercentageTypeEnumDto {
    fifteen = "15",
    seven = "7",
}

export class IrpfRetentionPercentageTypeDto {
    @IsEnum(IrpfRetentionPercentageTypeEnumDto)
    @IsNotEmpty()
    key!: IrpfRetentionPercentageTypeEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}